import { Box, useTheme } from "@mui/material";

function InternalTitle({ title }: { title: string }) {
	const theme = useTheme();
	return (
		<Box
			display="flex"
			alignItems="center"
			justifyContent="space-between"
			padding={4}
			borderBottom={1}
			borderColor={theme.palette.grey[200]}
			sx={{
				paddingX: theme.spacing(4),
				paddingY: theme.spacing(2)
			}}
		>
			{title}
		</Box>
	);
}

type PageSectionProps = React.PropsWithChildren<{
	title?: string | React.ReactNode;
	sx?: React.CSSProperties;
	contentSx?: React.CSSProperties;
}>;

export function PageSection({ title, sx, contentSx, children }: PageSectionProps) {
	const theme = useTheme();

	const _title = typeof title === "string" ? <InternalTitle title={title} /> : title;

	return (
		<Box
			flexGrow={0}
			display="flex"
			flexDirection="column"
			bgcolor={theme.palette.common.white}
			border={1}
			borderColor={theme.palette.grey[300]}
			sx={{
				boxShadow: "none",
				borderRadius: theme.shape.borderRadius,
				...sx
			}}
		>
			{_title}
			<Box
				padding={4}
				sx={{
					overflowY: "auto",
					"::-webkit-scrollbar": {
						width: "4px"
					},
					"::-webkit-scrollbar-thumb": {
						backgroundColor: theme.palette.grey[400],
						borderRadius: "2px"
					},
					"::-webkit-scrollbar-track": {
						backgroundColor: theme.palette.grey[100]
					},
					...contentSx
				}}
			>
				{children}
			</Box>
		</Box>
	);
}
